import React, { useState } from "react";
import { useFormik } from "formik";
import { FaTrash } from "react-icons/fa";
import styles from "./TrustedPartnersUpload.module.css";
import useToast from "../../../API/GlobalHooks/useToast";
import { useModal } from "../../ConfirmationModal/ModalContext";
import { handleDelete_TPLPage, handleGet_TPLPage, handleSubmit_TPLPage } from "./trustedPartnersModel";
import { getImageUrl } from "../../../MIS/Global";
import { useEffect } from "react";

const TrustedPartnersUpload = () => {
  const showToast = useToast();
  const { showModal } = useModal();
  const [loading, setLoading] = useState(false);
  const [listLoading, setListLoading] = useState(false);
  const [actionLoader, setActionLoader] = useState({});
  const [selectedImages, setSelectedImages] = useState([]);
  const [uploadedLogos, setUploadedLogos] = useState([]);

  useEffect(() => {
    handleGet_TPLPage({setListLoading,setUploadedLogos})
  },[])

  const validateImages = async (files) => {
    const validImages = [];
    const errors = [];

    for (let file of files) {
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      await new Promise((resolve) => {
        img.onload = () => {
          if (img.width === img.height) {
            validImages.push({
              file,
              preview: objectUrl,
            });
          } else {
            errors.push(`${file.name} is not square.`);
            URL.revokeObjectURL(objectUrl);
          }
          resolve();
        };
        img.src = objectUrl;
      });
    }

    return { validImages, errors };
  };

  const formik = useFormik({
    initialValues: {},
    onSubmit: () => {
      console.log("Submit:", selectedImages);
      let formData=new FormData();
      // Append each file
      selectedImages.forEach((img) => {
        formData.append("logo", img.file); // 👈 key must match backend
      });
      handleSubmit_TPLPage({setLoading,formData,showToast})      
      setSelectedImages([]);
    },
  });

  const handleImageChange = async (e) => {
    const files = Array.from(e.target.files);
    const { validImages, errors } = await validateImages(files);

    if (errors.length > 0) {
      alert(errors.join("\n"));
    }

    setSelectedImages((prev) => [...prev, ...validImages]);
  };

  const removeSelected = (index) => {
    const updated = [...selectedImages];
    updated.splice(index, 1);
    setSelectedImages(updated);
  };

 
  return (
    <div className="container-fluid mt-3">
      <div className={`card shadow-sm ${styles.cardWrapper}`}>
        <div className="card-body">

          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0">Trusted Partners Logos</h5>
            <span className="badge bg-primary">
              Total: {uploadedLogos.length}
            </span>
          </div>

          <form onSubmit={formik.handleSubmit}>

            {/* Compact Upload */}
            <div className="mb-3">
              <input
                type="file"
                multiple
                accept="image/*"
                className="form-control form-control-sm"
                onChange={handleImageChange}
              />
              <small className="text-muted">
                Only square images allowed
              </small>
            </div>

            {/* Selected Logos */}
            {selectedImages.length > 0 && (
              <>
                <h6 className="mb-2">
                  Selected ({selectedImages.length})
                </h6>
                <div className={styles.gridContainer}>
                  {selectedImages.map((img, index) => (
                    <div key={index} className={styles.logoBox}>
                      <img src={img.preview} alt="preview" />
                      <span
                        className={styles.deleteIcon}
                        onClick={() => removeSelected(index)}
                      >
                        <FaTrash size={12} />
                      </span>
                    </div>
                  ))}
                </div>
              </>
            )}

            {/* Uploaded Logos */}
            <h6 className="mt-4 mb-2">
              Uploaded Logos ({uploadedLogos.length})
            </h6>
            <div className={styles.gridContainer}>
              {uploadedLogos.map((logo) => (
                <div key={logo.id} className={styles.logoBox}>
                {/* {getImageUrl(`${logo.imgpath}`)} */}
                  <img src={getImageUrl(`${logo.imgpath}`)} alt="uploaded" />
                  <span
                    className={styles.deleteIcon}
                    onClick={() =>{
                        showModal({
                          title: "Confirm Deletion",
                          message: "Are you sure you want to delete?",
                          onConfirm: () => {
                            handleDelete_TPLPage({
                                item:logo,showToast,setUploadedLogos,
                                setActionLoader
                            })                            
                          },
                          confirmText: "Yes",
                          cancelText: "No",
                        });                            
                      }}                    
                  >
                    {actionLoader?.deleteId === logo.id ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (<>                                
                          <FaTrash size={12} />
                          </>
                    )} 
                  </span>
                </div>
              ))}
            </div>

            <div className="text-end mt-4">
              <button type="submit" className="btn btn-primary btn-sm px-4">
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Submitting...
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default TrustedPartnersUpload;
